// Phase 18 Plan 03 — POLISH-08 skip-to-main-content link.
//
// Rendered as the first focusable child of <RootApp> so a keyboard user's
// first Tab press reveals it. Visually hidden until focus (the `.skip-link`
// CSS recipe in globals.css slides it down from top: -40px to top: var(--space-2)
// on :focus / :focus-visible).
//
// Target: <main id="main" tabIndex={-1}> on every top-level screen (Plan 18-03
// Task 2 wires the id+tabIndex into 12 screens; Plan 18-03 Task 3 adds the
// router focus-on-navigate effect that re-targets the element on path change).
//
// i18n: label resolved through `a11y.skip_link` (en: "Skip to main content";
// sv: "Hoppa till huvudinnehåll"). The defaultMessage stays so the link still
// renders something readable if the dictionary fails to load.

import type { JSX } from 'react'
import { FormattedMessage } from 'react-intl'

export function SkipLink(): JSX.Element {
  return (
    <a href="#main" className="skip-link" data-testid="skip-link">
      <FormattedMessage
        id="a11y.skip_link"
        defaultMessage="Skip to main content"
      />
    </a>
  )
}
